/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductVariant } from '@msdyn365-commerce/retail-proxy';
import { Cell } from 'read-excel-file/types';

/**
 * EveOrderUploadStorage Input Action
 */
export class EveOrderUploadStorageInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `EVE-ORDER-UPLOAD-STORAGE`;
    public getCacheObjectType = () => 'EVE-ORDER-UPLOAD-STORAGE';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IEveOrderUploadStorageData {
    filename?: string;
    items?: {
        name?: string;
        itemNumber: string;
        configuration: string;
        source: string;
        quantity: number;
        notFound?: boolean;
        variants?: ProductVariant[];
    }[];
    itemsFoundOnSearch?: {
        name?: string;
        itemNumber: string;
        configuration: string;
        source: string;
        quantity: number;
        selectedVariant?: ProductVariant;
        variants?: ProductVariant[];
    }[];
    rejectedItems?: {
        itemNumber: Cell;
        configuration: Cell;
        source: Cell;
        quantity: Cell;
    }[];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new EveOrderUploadStorageInput();
};

async function action(input: EveOrderUploadStorageInput, ctx: Msdyn365.IActionContext): Promise<IEveOrderUploadStorageData> {
    return {};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IEveOrderUploadStorageData>>action,
    id: 'EveOrderUploadStorage',
    input: createInput
});
